import React, { Component } from 'react';
import { Row, Col } from 'antd';

class ViewInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }
  getData = () => {
    const {fieldItemGroups} = this.props;
    const data = [];
    if (!fieldItemGroups) {
      return [];
    }

    fieldItemGroups.forEach(fieldItemGroup => {
      if(!fieldItemGroup || !fieldItemGroup.fieldItems){
        return false;
      }

      fieldItemGroup.fieldItems.forEach(item => {
        data.push({
          text: item.label || item.alias,
          value: item.value,
          cols: item.columns,
          key: item.fieldDefinitionId
        });
      })
    });

    return data;
  }

  renderFields = (data) => {
    return (
      <Col span={data.cols * 12} key={data.key}>
        <strong>{data.text}: </strong>
        {data.value}
      </Col>
    );
  }

  render() {
    const fields = this.getData();
    return (
      <Row gutter={32}>
        {fields.map(this.renderFields)}
      </Row>
    );
  }
}

export default ViewInfo;
